import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const TopBanner = () => {
  const { banners } = useSelector((state) => state.ads);
  if (!banners?.top) {
    return null;
  }
  console.log('==', banners);
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-12'>
          <a
            href={banners?.top?.link}
            target='_blank'
            className='ads-link-wrap'
          >
            <div
              style={{
                display: 'block',
                width: '100%',
                height: '100%',
                backgroundImage: `url(${banners?.top?.img})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
            ></div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
